import React, { Component } from 'react';
import { connect } from 'react-redux';
import { pending } from 'redux-saga-thunk';
import { withRouter } from 'react-router';
import { compose } from 'redux';
import { notification } from 'antd';
import { reduxForm, reset } from 'redux-form';
import debounce from 'lodash/debounce';
import { fromEntities, fromResource } from '../../store/selectors';
import LocationTab from '../../components/molecules/LocationTab/index';
import { createValidator, required } from '../../services/validation/index';
import {
  resourceCreateRequest,
  resourceDetailReadRequest,
  resourceListReadRequest,
} from '../../store/resource/actions';

class LocationTabContainer extends Component {
  constructor(props) {
    super(props);
    this.lastFetchId = 0;
    this.fetchLocation = debounce(this.fetchLocation, 800);
  }

  state = {
    value: [],
  };

  fetchLocation = value => {
    this.lastFetchId += 1;
    const fetchId = this.lastFetchId;
    if (fetchId !== this.lastFetchId || !value) {
      // for fetch callback order
      return;
    }

    this.props.searchLocation(value);
  };

  handleChange = value => {
    this.setState({
      value,
    });
  };

  render() {
    const { value } = this.state;
    const data = this.props.locationData.map(location => ({
      text: location.addr
        ? `${location.chain_name} - ${location.addr}, ${location.city}, ${location.state} ${location.zip}`
        : `${location.chain_name}`,
      value: location.location_id,
    }));

    return (
      <LocationTab
        handleChange={this.handleChange}
        fetching={this.props.fetching}
        data={data}
        value={value}
        fetchLocation={this.fetchLocation}
        {...this.props}
      />
    );
  }
}

const mapStateToProps = (
  state,
  {
    match: {
      params: { forecastId, lineItemId, revisionId },
    },
  }
) => {
  const itemId = lineItemId || revisionId;
  const resource = lineItemId ? 'advertiser-ad' : `forecast/${forecastId}/revision`;

  return {
    uploadEndpoint: `${process.env.REACT_APP_INMARKET_API}/${resource}/${itemId}/location/upload`,
    locationData: fromEntities.getList(state, 'location', fromResource.getList(state, 'location')),
    fetching: pending(state, 'locationListRead'),
    initialValues: {
      method: 'search',
    },
  };
};

const mapDispatchToProps = (
  dispatch,
  {
    match: {
      params: { forecastId, lineItemId, revisionId },
    },
  }
) => {
  const itemId = lineItemId || revisionId;
  const resource = lineItemId ? 'advertiser-ad/:id' : 'forecast/:forecastId/revision/:id';
  const needle = { id: itemId, forecastId };

  return {
    getLocation: () => dispatch(resourceDetailReadRequest(`${resource}/location`, needle)),
    getLocationList: () => dispatch(resourceListReadRequest(`${resource}/location`, {}, needle)),
    addLocations: locationIds =>
      dispatch(resourceCreateRequest(`${resource}/location`, needle, locationIds)),
    searchLocation: q =>
      dispatch(
        resourceListReadRequest('location', {
          q,
          [lineItemId ? 'advertiser_ad_id' : 'forecast_revision_id']: needle.id,
        })
      ),
  };
};

const onSubmit = (values, dispatch, props) => {
  if (values.locations) {
    return props
      .addLocations(values.locations)
      .then(() => {
        dispatch(reset('LocationTab'));
        notification.success({
          message: 'Success',
          description: 'Locations included.',
          duration: 4,
        });
      })
      .catch(e =>
        notification.error({
          message: 'Error',
          description: typeof e === 'string' ? e : 'Could not include locations.',
          duration: 0,
        })
      );
  }
};

const validate = createValidator({
  location: [required],
});

export default compose(
  withRouter,
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  reduxForm({
    form: 'LocationTab',
    onSubmit,
    validate,
    onChange: (values, dispatch, props) => {
      if (values.locationList) {
        notification.success({
          message: 'Success',
          description: 'CSV uploaded successfully',
          duration: 4,
        });
        props.getLocationList();
        dispatch(reset('LocationTab'));
      }
    },
  })
)(LocationTabContainer);
